// extracted by mini-css-extract-plugin
module.exports = {"collapsible":"help_collapsible__14XCg"};